import { fg } from '@atlaskit/platform-feature-flags';

import { useBFFOriginUrlContext } from '../providers/origin-provider-context';

/**
 * Hooks that returns the context of a forced origin url if FG is enabled and forceOriginUrl is provided to the context
 */
const useOriginUrl = () => {
	const context = useBFFOriginUrlContext();
	if (!fg('navx-1147-support-global-shortcuts-locally')) {
		return undefined;
	}
	return context;
};

export default useOriginUrl;
